import request from '@/util/axios'

// 获取admin
export const getAdminUserRules = params => {
    return request({
      url: "/api/AdminPublic/UserManager",
      method: 'get',
      params
    })
}


//admin 端公共数据下拉
export const getPublicSelect = (isSeller) => {
  let url = '/api/AdminPublic'
  if(isSeller){
    url = '/store/SellerAdmin/SellerPublic/PublicSelect'
  }
  return request({
    url: `${url}/PublicSelect`,
    method: 'post',
    data:{}
  })
}

//控制台首页数据
export const getSellerHome = data => {
  return request({
    url: `/api/Home/QueryHomeDataStatistics`,
    method: 'post',
    data
  })
}

//获取通知
export const getNotices = data => {
  return request({
    url: `/api/home/QueryMessage`,
    method: 'post',
    data:{
      PageNo:1,
      PageSize:9999
    }
  })
}

export const improtOrder = file => {
  return request({
    url: `/api/OrderImport/ImportOrderAsync`,
    method: 'post',
    data:{
      file
    }
  })

}
